import { CallPriority, CallStatus } from '@/types/call';

export const CALL_STATUS_LABELS: Record<CallStatus, string> = {
    OPENED: 'Aberto',
    TRIAGE: 'Em triagem',
    ASSIGNED: 'Atribuído',
    IN_PROGRESS: 'Em andamento',
    WAITING: 'Aguardando',
    RESOLVED: 'Resolvido',
    CLOSED: 'Fechado',
    COMPLETED: 'Concluído',
    CANCELED: 'Cancelado',
};

export const CALL_PRIORITY_LABELS: Record<CallPriority, string> = {
    LOW: 'Baixa',
    NORMAL: 'Normal',
    HIGH: 'Alta',
    URGENT: 'Urgente',
};


export const CALL_STATUS_STYLES: Record<CallStatus, string> = {
    OPENED: 'border-blue-500/30 bg-blue-500/10 text-blue-300',
    TRIAGE: 'border-violet-500/30 bg-violet-500/10 text-violet-300',
    ASSIGNED: 'border-cyan-500/30 bg-cyan-500/10 text-cyan-300',
    IN_PROGRESS: 'border-amber-500/30 bg-amber-500/10 text-amber-300',
    WAITING: 'border-orange-500/30 bg-orange-500/10 text-orange-300',
    RESOLVED: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-300',
    CLOSED: 'border-slate-500/30 bg-slate-500/10 text-slate-300',
    COMPLETED: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-300',
    CANCELED: 'border-red-500/30 bg-red-500/10 text-red-300',
};

export const CALL_PRIORITY_STYLES: Record<CallPriority, string> = {
    LOW: 'border-sky-500/25 bg-sky-500/10 text-sky-300',
    NORMAL: 'border-emerald-500/25 bg-emerald-500/10 text-emerald-300',
    HIGH: 'border-amber-500/25 bg-amber-500/10 text-amber-300',
    URGENT: 'border-red-500/30 bg-red-500/10 text-red-300',
};

export const formatCallProtocol = (id: string) => `#${id.slice(0, 8).toUpperCase()}`;

export const formatCallDate = (value?: string | null, withTime = true) => {
    if (!value) return 'Não informado';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return 'Não informado';
    return new Intl.DateTimeFormat('pt-BR', {
        dateStyle: 'short',
        ...(withTime ? { timeStyle: 'short' as const } : {}),
    }).format(date);
};

export const formatFileSize = (size: number) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
};

export const isCallClosed = (status: CallStatus) => status === 'CLOSED' || status === 'COMPLETED';
